import './projectLinks.scss';
import * as React from 'react';
import { icons } from '../../content/icons';
import { RMButton } from '../layout/rmButton';
import { DownloadLink } from './downloadLink';
export const ProjectLinks = ({ download_links, project_url, project_url_short, buttonVariant }) => (<div className="project-links">
    {download_links?.android && <DownloadLink href={download_links.android} platform="android"/>}
    {download_links?.ios && <DownloadLink href={download_links.ios} platform="ios"/>}
    {project_url && (<a href={project_url} target="_blank" rel="noopener noreferrer">
        <RMButton name={`visit ${project_url_short}`} variant={buttonVariant} rightIcon={icons.right}>
          {`Visit ${project_url_short}`}
        </RMButton>
      </a>)}
  </div>);
ProjectLinks.defaultProps = {
    buttonVariant: 'darken-bg',
};
